//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
  SMARTWITNESS_VIDEO_GET_SNAPSHOTS_URLS,
  SMARTWITNESS_VIDEO_REFRESH_SNAPSHOTS_URLS,
  SMARTWITNESS_VIDEO_SAVE_SNAPSHOTS_URLS
} from 'Redux/actionTypes';

//actions
import {
  getSnapshotsUrlsResponse,
  refreshSnapshotsUrlsResponse,
  saveSnapshotsUrlsResponse
} from 'Redux/actions';

/* QUERIES */
const SNAPSHOT_QUERY = `
  query searchSmartWitnessSnapshotLive($recorderId: String!) {
    searchSmartWitnessSnapshotLive(recorderId: $recorderId) {
      error
      errorInfo {
        Code
        Message
      }
      data {
        Camera
        Altitude
        ContentSize
        EndDateTime
        FileFormat
        Heading
        Latitude
        Longitude
        MDTURL
        Speed
        StartDateTime
        URL
      }
    }
  }
`;

/* SAGAS */

function* getSnapshotsUrlsRequest({ payload }) {
  const { data } = payload;
  const { recorderId, user } = data;

  try {
    const response = yield call(
      clientQuery,
      SNAPSHOT_QUERY,
      { recorderId },
      endpoints.GRAPHQL_GENERAL_V2,
    );

    const result = response?.searchSmartWitnessSnapshotLive;

    if (!result || result.error) {
      yield put(getSnapshotsUrlsResponse({
        recorderId,
        error: true,
        message: result?.errorInfo?.Message || 'smartwitness_errorAccessDenied',
        Code: result?.errorInfo?.Code || 202,
        data: result?.errorInfo
      }));
      return;
    }

    let newResult = result.data.map(r => {
      const speed = r?.Speed ? parseInt(r.Speed) : 0;
      return { ...r, Speed: user?.isKph ? speed : speed * 0.6213 };
    });

    yield put(getSnapshotsUrlsResponse({ recorderId, data: newResult }));
  } catch (exc) {
    yield put(getSnapshotsUrlsResponse({
      error: true,
      message: 'smartwitness_errorAccessDenied',
      recorderId,
      Code: 202,
      data: []
    }));
    ExceptionManager(exc, 'modules/.common/components/SmartWitnessVideo/redux', 'Error while getting smartwitness snapshots urls');
  }
}

function* refreshSnapshotsUrlsRequest({ payload }) {
  const { data } = payload;
  const { recorderId, user } = data;

  try {
    const response = yield call(
      clientQuery,
      SNAPSHOT_QUERY,
      { recorderId },
      endpoints.GRAPHQL_GENERAL_V2,
    );

    const result = response?.searchSmartWitnessSnapshotLive;

    if (!result || result.error) {
      
      yield put(refreshSnapshotsUrlsResponse({
        recorderId,
        error: true,
        message: result?.errorInfo?.Message || 'smartwitness_errorAccessDenied',
        Code: result?.errorInfo?.Code || 202,
        data: result?.errorInfo
      }));
      return;
    }

    let newResult = result.data.map(r => {
      const speed = r?.Speed ? parseInt(r.Speed) : 0;
      return { ...r, Speed: user?.isKph ? speed : speed * 0.6213 };
    });

    yield put(refreshSnapshotsUrlsResponse({ recorderId, data: newResult }));
  } catch (exc) {
    yield put(refreshSnapshotsUrlsResponse({
      error: true,
      message: 'smartwitness_errorAccessDenied',
      recorderId,
      data: []
    }));
    ExceptionManager(exc, 'modules/.common/components/SmartWitnessVideo/redux', 'Error while refreshing smartwitness snapshots urls');
  }
}

function* saveSnapshotsUrlsRequest({ payload }) {
  const { data } = payload;

  try {
    const response = yield call(
      clientMutation,
      `mutation createSWMedia (
        $deviceId: String!,
        $media: AWSJSON!
      ) {
        Snapshot: createSWMedia (
          deviceId: $deviceId,
          media: $media
        ) {
          eventId  
          uuid
          eventType
          deviceId 
        }
      }`,
      data,
      endpoints.GRAPHQL_GENERAL,
    );

    if (response && response.Snapshot) {
      yield put(saveSnapshotsUrlsResponse({ ...response.Snapshot, recorderId: data?.recorderId }));
    } else {
      throw 'Error while saving snapshots urls for smart witness';
    }
  } catch (exc) {
    // ALWAYS RETURN ACTION
    ExceptionManager(exc, 'modules/.common/components/SmartWitnessVideo/redux/saga', 'saveSnapshotsUrlsRequest');
    yield put(saveSnapshotsUrlsResponse({ recorderId: data?.recorderId, error: true }));
  }
}

function* watchGetSnapshotsUrlsRequest() {
  yield takeEvery(SMARTWITNESS_VIDEO_GET_SNAPSHOTS_URLS, getSnapshotsUrlsRequest);
}

function* watchRefreshSnapshotsUrlsRequest() {
  yield takeEvery(SMARTWITNESS_VIDEO_REFRESH_SNAPSHOTS_URLS, refreshSnapshotsUrlsRequest);
}

function* watchSaveSnapshotsUrlsRequest() {
  yield takeEvery(SMARTWITNESS_VIDEO_SAVE_SNAPSHOTS_URLS, saveSnapshotsUrlsRequest);
}

//merge sagas
export default function* rootSaga() {
  yield all([
    fork(watchGetSnapshotsUrlsRequest),
    fork(watchRefreshSnapshotsUrlsRequest),
    fork(watchSaveSnapshotsUrlsRequest)
  ]);
}
